// not working production build
import { parseCookies } from 'nookies'

declare global {
  interface Window {
    gtag: any
    dataLayer: Record<string, unknown>[]
  }
}

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID || ''
export const GTM_TRACKING_ID = process.env.NEXT_PUBLIC_GTM_ID || ''

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}

export const GTM_EVENT_SING_UP_PV = 'sign-up-pv'
export const GTM_EVENT_SING_UP_COMPLETE = 'sign-up-complete'

export const GTM_EVENT_LOGIN_PV = 'login-pv'
export const GTM_EVENT_LOGIN_COMPLETE = 'login-complete'

export const GTM_EVENT_RESERVE_MODAL_PV = 'reserve-modal-pv'
export const GTM_EVENT_RESERVE_CONFIRM_PV = 'reserve-confirm-pv'
export const GTM_EVENT_RESERVE_COMPLETE = 'reserve-complete'

export const GTM_EVENT_CLICK_FILTER_TODAY = 'click-filter-today'
export const GTM_EVENT_CLICK_FILTER_TOMORROW = 'click-filter-tomorrow'
export const GTM_EVENT_CLICK_FILTER_OPEN_24_HOURS = 'click-filter-open-24-hours'

// Auth funnel events
export const GTM_EVENT_AUTH_SIGNUP_SCREEN_VIEW = 'auth_signup_screen_view'
export const GTM_EVENT_AUTH_SIGNUP_METHOD_GOOGLE = 'auth_signup_method_google'
export const GTM_EVENT_AUTH_SIGNUP_METHOD_APPLE = 'auth_signup_method_apple'
export const GTM_EVENT_AUTH_SIGNUP_METHOD_PHONE_EMAIL = 'auth_signup_method_phone_email'
export const GTM_EVENT_AUTH_SIGNUP_FORM_VIEW = 'auth_signup_form_view'
export const GTM_EVENT_AUTH_SIGNUP_OTP_VIEW = 'auth_signup_otp_view'
export const GTM_EVENT_AUTH_SIGNUP_COMPLETE = 'auth_signup_complete'
export const GTM_EVENT_AUTH_SIGNUP_RETURN_SCREEN = 'auth_signup_return_screen'

export const GTM_EVENT_AUTH_LOGIN_SCREEN_VIEW = 'auth_login_screen_view'
export const GTM_EVENT_AUTH_LOGIN_METHOD_GOOGLE = 'auth_login_method_google'
export const GTM_EVENT_AUTH_LOGIN_METHOD_APPLE = 'auth_login_method_apple'
export const GTM_EVENT_AUTH_LOGIN_METHOD_PHONE_EMAIL = 'auth_login_method_phone_email'
export const GTM_EVENT_AUTH_LOGIN_OTP_VIEW = 'auth_login_otp_view'
export const GTM_EVENT_AUTH_LOGIN_COMPLETE = 'auth_login_complete'
export const GTM_EVENT_AUTH_LOGIN_RETURN_SCREEN = 'auth_login_return_screen'

type GtmAuthMethod = 'google' | 'apple' | 'facebook' | 'email' | 'phone'
type GtmAuthFlow = 'signup' | 'login'
type GtmCustomEventType = 'scroll' | 'screen_tracking'

export const sendGtmEvent = ({
  eventName,
  method,
  flow,
  locale,
  eventType,
  spaceId,
}: {
  eventName: string
  method?: GtmAuthMethod
  flow?: GtmAuthFlow
  locale?: string
  eventType?: GtmCustomEventType
  spaceId?: string
}) => {
  const cookies = parseCookies()
  const affiliateTag = cookies.affiliate_tag || null

  window.dataLayer.push({
    event: eventName,
    ...(method && { method }),
    ...(flow && { flow }),
    ...(locale && { locale }),
    ...(affiliateTag && { affiliate_tag: affiliateTag }),
    ...(eventType && { custom_event_type: eventType }),
    ...(spaceId && { space_id: spaceId }),
  })
}
